<template>
  <v-card color="white"
          min-height="484px">
    <v-textarea v-model="customerProject.project.description"
                name="description"
                label="Project Description"
                rows="5"
                variant="solo-filled"
                required></v-textarea>
    <v-file-input :model-value="customerProject.project.images"
                  label="Upload Images"
                  accept="image/*"
                  name="images[]"
                  ref="nativeFileInput"
                  chips
                  clearable
                  variant="solo-filled"
                  show-size
                  prepend-icon="mdi-camera"
                  multiple
                  @update:model-value="addImage"
                  @click:clear="() => removeImage(null)">

    </v-file-input>

    <ImagePreview :images="customerProject.project.images"
                  deletable
                  @removeImage="removeImage"></ImagePreview>
  </v-card>
</template>

<script lang="ts" setup>
// Import the Project interface
import type { ContactModel } from '~/models/contactModel';
const nativeFileInput = ref<HTMLInputElement | null>(null);
// Bind to parent using defineModel
const customerProject = defineModel<ContactModel>({
  default: {
    project: {
      description: '',
      images: [],
    },
  },
});

function addImage(newImages: File | File[]) {
  const files = Array.isArray(newImages) ? newImages : [newImages];
  customerProject.value.project.images.push(...files);

  // Update the native file input so emailjs.sendForm picks them up
  const nativeInput = nativeFileInput.value as HTMLInputElement;
  if (nativeInput) {
    const dataTransfer = new DataTransfer();
    customerProject.value.project.images.forEach(file => dataTransfer.items.add(file));
    nativeInput.files = dataTransfer.files;
  }
}

function removeImage(index: number | null = null) {
  if (index !== null) {
    customerProject.value.project.images.splice(index, 1);
  } else {
    customerProject.value.project.images = [];
  }
}

</script>

<style></style>